"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allEpics = void 0;
const ro = require("redux-observable");
const recipients_1 = require("./recipients");
const billingInformations_1 = require("./billingInformations");
const addressBook_1 = require("./addressBook");
const _printProviders = require("../../modules/printProviders/epics");
const newExternalUser_1 = require("./newExternalUser");
const _finishings = require("../../modules/finishings/epics");
const distributionLists_1 = require("./distributionLists");
const _deliveryMethods = require("../../modules/deliveryMethods/epics");
const list_1 = require("./list");
const wizard_1 = require("./wizard");
const deliveryMethods = _deliveryMethods.default('order');
const finishings = _finishings.default('order');
const printProviders = _printProviders.default('order');
exports.allEpics = ro.combineEpics(list_1.fetchOrderList, wizard_1.fetchOrderFiles, list_1.deleteAutomaticOrderTemplate, list_1.copyAutomaticOrderTemplate, addressBook_1.fetchExternalUsers, billingInformations_1.fetchBillingInformations, deliveryMethods.fetchDeliveryMethods, distributionLists_1.distributionLists, finishings.fetchFinishings, newExternalUser_1.newExternalUserEpics, printProviders.fetchPrintProviders, recipients_1.fetchRecipients, wizard_1.deleteAutomaticOrderTemplate, wizard_1.changeStep, wizard_1.createNewOrder, wizard_1.prevalidateFiles, wizard_1.prevalidateImportedFiles, wizard_1.fetchOrder, wizard_1.fetchOrderRecipients);
//# sourceMappingURL=index.js.map